import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { searchContacts } from "../../../store/middleware";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import Avatar from "../../../assets/images/profile/img_placeholder.svg";
import { setContract } from "../../../store/slices/b2b/b2bContracts.slice";

function ContactSearch(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contract } = useSelector((state) => state.b2bContractsReducer);

  const [generalState, setGeneralState] = useState({ searchTerm: "", done: false });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setGeneralState((state) => ({ ...state, [name]: value }));
  };

  const addContact = (e) => {
    e.preventDefault();
    const { dataset } = e.target;
    const { contactsFound } = props;
    const contact = contactsFound[dataset.index];
    let list = [...contract.contractContacts];

    list.push(contact);

    dispatch(setContract({ ...contract, contractContacts: list }));
    setGeneralState({ searchTerm: "", done: false });
    props.setContactsFound(null);
  };

  const clearSearch = () => {
    setGeneralState({ searchTerm: "", done: false });
    props.setContactsFound(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (generalState.searchTerm && generalState.searchTerm.length > 0) {
      dispatch(
        searchContacts(generalState.searchTerm, (items) => {
          setGeneralState((state) => ({ ...state, done: true }));
          props.setContactsFound(items);
        }),
      );
    }
  };

  const { contactsFound } = props;
  return (
    <div className="contacts">
      <h4>{t("CONTACTS")}</h4>
      <div>
        <label>{t("SEARCH_USER")}</label>
      </div>
      <input
        type="search"
        value={generalState.searchTerm}
        onChange={handleChange}
        name="searchTerm"
        placeholder="Name"
      />
      <SCButtonAddInput ml="12px" background="#004fff" color="#fff" onClick={(e) => handleSubmit(e)} value="Search">
        {t("BTN_SEARCH")}
      </SCButtonAddInput>
      {contactsFound?.length === 0 && generalState.done && (
        <>
          {" "}
          <br />
          <span style={{ color: "red", fontSize: "12px" }}>No contacts found.</span>
        </>
      )}
      {contactsFound?.length > 0 && (
        <div className="results">
          <div className="overflow">
            {contactsFound?.map((item, index) => {
              return (
                <div key={index * 8} className="boxResults card">
                  <img src={item.user.picture ? item.user.picute : Avatar} alt="Avatar" />
                  <div>
                    <div>
                      <h5>{item.user.name}</h5>
                    </div>
                  </div>
                  <div style={{ marginRight: "10px" }}>
                    <SCButtonAddInput data-index={index} onClick={(e) => addContact(e)}>
                      {t("ADD_TO_CONTRACT")} +
                    </SCButtonAddInput>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {contactsFound?.length > 0 && (
        <div className="clear-search">
          <button type="button" onClick={clearSearch}>
            {t("BTN_CLEAR_SEARCH")}
          </button>
        </div>
      )}
    </div>
  );
}

export default ContactSearch;
